module.exports = __webpack_public_path__ + "img/silhouette-flower.ac1e7fa9.png";